import { useEffect, useState } from "react";
import {
  getCart,
  removeFromCart,
  updateQuantity,
} from "../utils/cart";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import "../styles/Cart.css";

export default function Cart() {
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();

  // 🔄 LOAD CART
  const loadCart = () => {
    const data = getCart();
    setCart(data && data.length > 0 ? data : []);
  };

  useEffect(() => {
    loadCart();

    window.addEventListener("storage", loadCart);
    return () => window.removeEventListener("storage", loadCart);
  }, []);

  // 💰 SINGLE SHIPPING TOTAL LOGIC
  const total = (() => {
    // 🧮 Product total
    const itemsTotal = cart.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    );

    // 🚚 Highest shipping from all products
    let shipping = Math.max(...cart.map((i) => i.shipping || 0), 0);

    console.log(cart);
    // 🔢 Total quantity of all items
    const totalQty = cart.reduce(
      (acc, item) => acc + item.quantity,
      0
    );

    // 📦 Apply quantity-based shipping rule
    if (totalQty >= 2 && totalQty <= 5) {
      shipping = shipping * 1.5;
    } else if (totalQty > 5) {
      shipping = shipping * 2;
    }

    return itemsTotal + shipping;
  })();
  

  return (
    <div className="cart-container">
      <h2>🛒 Your Cart</h2>

      {cart.length === 0 ? (
        <div className="empty-cart">
          <h2>Your cart is empty</h2>
          <p>Looks like you haven’t added anything yet</p>

          <button
            className="shop-btn"
            onClick={() => navigate("/")}
          >
            Continue Shopping
          </button>
        </div>
      ) : (
        <>
          {/* 🛍 CART ITEMS */}
          {cart.map((item) => (
            <div key={item.id} className="cart-item">

              {/* IMAGE */}
              <img
                src={item.image}
                alt={item.name}
                className="cart-img"
              />

              {/* INFO */}
              <div className="cart-info">
                <h4>{item.name}</h4>

                <p className="price">₹{item.price}</p>

                {/* 🔢 QUANTITY */}
                <div className="qty-controls">
                  <button
                    onClick={() => {
                      updateQuantity(item.id, "dec");
                      loadCart();
                    }}
                  >
                    -
                  </button>

                  <span>{item.quantity}</span>

                  <button
                    onClick={() => {
                      updateQuantity(item.id, "inc");
                      loadCart();
                    }}
                  >
                    +
                  </button>
                </div>

                {/* ✅ PRODUCT TOTAL ONLY */}
                <p className="item-total">
                  Total: ₹{item.price * item.quantity}
                </p>
              </div>

              {/* ❌ DELETE */}
              <button
                className="delete-btn"
                onClick={() => {
                  removeFromCart(item.id);
                  loadCart();
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </div>
          ))}

          {/* 💰 SUMMARY */}
          <div className="cart-summary">
            <h3>Total Amount: ₹{total}</h3>

            <p className="shipping-note">
              (Shipping charges included)
            </p>

            <button
              className="checkout-btn"
              onClick={() =>
                navigate("/prebook/cart", {
                  state: { cart, total },
                })
              }
            >
              Proceed to Order
            </button>
          </div>
        </>
      )}
    </div>
  );
}